export const VALOR_FORBIDDEN_LOG_DATA_KEYS = ['appid', 'appkey', 'channel'] as const;

export type ValorForbiddenLogDataKey = (typeof VALOR_FORBIDDEN_LOG_DATA_KEYS)[number];
